
import { defineComponent } from 'vue'
import { mapState, useStore, mapGetters } from 'vuex'
import { isAndroidNative as isAndroid, isIOSNative as isIOS } from '@xunlei/universal-native-api'
// import PanNewFolder from '@remote/components/PanNewFolder.vue'
import PanListFooter from '@remote/components/PanListFooter.vue'
// import { TASK_TYPE_IDS } from '@remote/constant'

import { parseTime, isToday, bytesToSize } from '@remote/utils'
import { isLargeViewPort } from '@remote/utils/base'
import { request } from '@remote/api/request'
import remove from 'lodash/remove'
import { IErrorRes } from '@remote/type'
import { IGetFilessResult } from '@remote/type/yunpan'
import global from '@remote/store/constantStore'
import { usePathSelector } from '@remote/store/hezi-file/path-selector'
import { useTasks } from '@remote/store/task'
import LoadMore from '@remote/components/LoadMore.vue'
import { toast } from '@remote/utils/dialog'

const DRIVE_API = {
  test: 'https://api-alpha-drive.office.k8s.xunlei.cn/drive/v1/',
  prod: 'https://api-pan.xunlei.com/drive/v1/',
}

const Env = 'prod'

export default defineComponent({
  name: 'PanList',
  props: {
    totalList: Array,
    parentId: {
      type: String,
      default: '',
    },
    filters: {
      type: String,
      default: JSON.stringify({
        trashed: {
          eq: false,
        },
        phase: {
          eq: 'PHASE_TYPE_COMPLETE',
        },
        /* kind: {
          eq: 'drive#folder'
        } */
      }),
    },
    limit: {
      type: Number,
      default: 100,
    },
    hasFooter: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    // PanNewFolder,
    PanListFooter,
    LoadMore,
  },
  setup: () => {
    document.title = '从云盘创建下载任务'
    const { selectedPath } = usePathSelector()
    const taskStore = useTasks()
    return {
      store: useStore(),
      selectedPath,
      taskStore,
    }
  },
  data () {
    return {
      all: {} as any, // 缓存文件
      caches: {}, // 根据 parentId来缓存对应的文件id
      files: [],
      next_page_token: '',
      currentParentId: '',
      folderPath: [
        {
          name: '我的云盘',
          id: '',
          _id: 0,
          showName: '我的云盘',
        },
      ],
      folderPathLite: [] as any[],
      newFolderShow: false,
      errorInfo: '',
      errorShow: true,
      safeBoxIsNew: false,
      img: {
        new: import('@remote/assets/pan/new.png'),
      },
      isLoading: false,
      checkNum: 0,
      chooseFile: [] as any[],
      isSelecting: false,
      isSelectAll: false,
      canDownloadedFileNum: 0,
      isUnMounted: false,
      hasMore: true,
      isLargeViewPort: isLargeViewPort(),
      isAndroid,
      isIOS,
    }
  },
  computed: {
    // ...mapState(['action']),
    ...mapGetters(['isVip', 'isFullScreen']),
  },
  // watch: {
  //   action (val) {
  //     if (val === 'check') {
  //       this.store.commit('update', { selects: [], taskType: TASK_TYPE_IDS[this.checkNum]  })
  //       this.store.dispatch('getTasks')
  //       this.$router.back()
  //     } else if (val === 'download') {
  //       this.store.commit('dialog', { show: false })
  //       this.download()
  //     } else if (val === 'confirm') {
  //       this.store.commit('dialog', { show: false })
  //       this.confirm()
  //     }
  //   },
  // },
  mounted () {
    this.getFiles(this.parentId, 'mounted')
    window.addEventListener('resize', this.onresize)
  },
  unmounted () {
    this.isUnMounted = true
    window.removeEventListener('resize', this.onresize)
  },
  methods: {
    isToday,
    parseTime,
    bytesToSize,
    onresize () {
      this.isLargeViewPort = isLargeViewPort()
    },
    hide () {
      this.currentParentId = ''
      this.folderPath = [
        {
          name: '我的云盘',
          id: '',
          _id: 0,
          showName: '我的云盘',
        },
      ]
      this.folderPathLite = []
      this.getFiles('', 'hide')
      this.$emit('closePath', false)
    },
    async getFiles (id = '', caller = '') {
      console.log('getFiles', 1, caller)
      if (this.isUnMounted) return
      this.files = this.caches[id || '0'] || []
      const params = {
        parent_id: id,
        limit: this.limit,
        with_audit: true,
        filters: this.filters,
        page_token: this.next_page_token,
      }
      // const url = `${DRIVE_API[Env]}files?${qs.stringify(params)}`
      this.isLoading = true
      let [err, res]: [IErrorRes, IGetFilessResult] = await request('/drive/v1/files', params, { apiEnv: 'production' })
      if (this.isUnMounted) return
      if (err) return toast({type: 'error', message: err.error_description})
      if (res.files) {
        // const safeBox = remove(res.files, { name: '超级保险箱' })
        const dump = remove(res.files, { name: '我的转存' })
        const resource = remove(res.files, { name: '我的资源' })
        const compress = remove(res.files, { name: '在线解压' })
        const zhan = remove(res.files, { name: '小站收藏' })
        // const newFiles = safeBox.concat(dump, resource, compress, zhan, res.files)
        const defaultDirs = dump.concat(resource, compress, zhan)?.map(item => ({ ...item, isDefault: true }))
        const restAllFloders = res.files?.reverse()?.filter(item => item.kind === 'drive#folder')
        const restAllFliles = res.files?.reverse()?.filter(item => item.kind === 'drive#file')
        let auditDisableNum = 0
        // @ts-ignore
        const files = defaultDirs.concat(restAllFloders, restAllFliles).map(v => {
          const status = v.audit?.status
          const isAuditDisable = (status === 'STATUS_SENSITIVE_RESOURCE' || status === 'STATUS_SENSITIVE_WORD') && v.kind === 'drive#file'
          v.auditDisableType = isAuditDisable ? 1 : 0
          v.checkType = 0
          this.all[v.id] = v
          if (isAuditDisable) auditDisableNum+=1
          return v.id
        })
        // @ts-ignore
        const nextFiles = params.page_token ? [].concat(this.files, files) : files
        this.caches[id || '0'] = nextFiles
        this.files = nextFiles
        this.next_page_token = res.next_page_token
        this.canDownloadedFileNum = nextFiles.length - defaultDirs.length - auditDisableNum
      }
      this.isLoading = false
    },
    loadMore () {
      this.getFiles(this.currentParentId, 'loadMore')
    },
    handleCancel () {
      this.chooseFile.forEach(file => {
        this.all[file.id].checkType = 0
      })
      this.chooseFile = []
      this.isSelectAll = false
      this.isSelecting = false
    },
    // 点击面包屑更新文件列表
    handleClickBreadCrumb (folder) {
      if (this.chooseFile.length > 0 || this.isSelecting && !this.isLargeViewPort || !folder) return
      console.log('folder :>> ', folder, this.all, this.folderPath, this.folderPath.length)
      console.log('object :>> ', folder._id === this.folderPath.length - 1)
      if (folder.id === '' && folder._id === 0) {
        this.hide()
        return
      }
      const file = this.all[folder.id]
      if (file._id !== this.folderPath.length - 1) {
        this.currentParentId = file.id
      }
      this.next_page_token = ''
      this.handleFolderPath(file)
      this.getFiles(this.currentParentId, 'clickBreadCrumbHandler')
    },
    handleClickItem (id: string) {
      const file = this.all[id]

      if (file._id !== this.folderPath.length - 1) {
        this.currentParentId = file.id
      }

      const isSelectedState = this.isLargeViewPort ? !!this.chooseFile.length : this.isSelecting
      if (isSelectedState) {
        if (file.auditDisableType === 1) {
          return  toast({type: 'error', message: '违规资源，无法下载'})
        }
        // 特殊文件夹禁止选择
        if (file.isDefault) return
        return this.handleSelectItem(file)
      } else {
        if (file.auditDisableType === 1) {
          return toast({type: 'error', message: '违规资源，无法打开'})
        }

        if (file.kind == 'drive#file') {
          // 文件消费
          toast({type: 'info', message: '请下载到设备后再打开'})
        } else {
          // 切换目录
          this.next_page_token = ''
          this.handleFolderPath(file)
          this.getFiles(this.currentParentId, 'handleClickItem')
        }
      }
    },
    handleOnPressItem (id) {
      if (this.isLargeViewPort) return
      this.handleSelectItem(this.all[id])
    },
    handleSelectItem (file) {
      this.isSelecting = true
      if (file.checkType === 1) {
        const index = this.chooseFile.findIndex((item) => item.id === file.id)
        this.chooseFile.splice(index, 1)
        file.checkType = 0
      } else {
        this.chooseFile.push(file)
        file.checkType = 1
      }
      this.isSelectAll = this.chooseFile.length === this.canDownloadedFileNum
    },
    handleSelectAll () {
      this.isSelectAll = !this.isSelectAll
      // this.isSelecting = this.isSelectAll
      this.files.forEach(id => {
        const file = this.all[id]
        if (file.auditDisableType !== 0) return
        if (this.isSelectAll) {
          if (!file.isDefault && file.checkType !== 1) {
            this.chooseFile.push(file)
            file.checkType = 1
          }
        } else {
          if (!file.isDefault && file.checkType === 1) {
            file.checkType = 0
          }
        }
      })
      if (!this.isSelectAll) this.chooseFile = []
    },
    handleFolderPath (file) {
      let ret = this.folderPath.filter(elm => {
        return file.id === elm.id
      })
      if (ret.length) {
        this.folderPath.splice(ret[0]._id + 1, this.folderPath.length - 1)
      } else {
        const substrEnd = 9 
        this.folderPath.push({
          id: file.id,
          name: file.name,
          showName: file.name.length > 5 ? `${file.name.substr(0, substrEnd)}...` : file.name,
          _id: this.folderPath.length,
        })
      }
      this.folderPathLite = this.folderPath.map((elm, idx) => {
        return elm.name
      })
      console.log('this.folderPathLite :>> ', this.folderPathLite)
      this.folderPathLite.splice(0, 1)
    },
    async confirm () {
      const downloadUrls: string[] = []
      this.chooseFile.forEach(file => {
        const userId = global.userId
        const fileType = file.kind === 'drive#folder' ? 'folder' : 'file'
        const url = `xdrive://hezi/${userId}/${fileType}/${file.id}`
        downloadUrls.push(url)
        this.taskStore.setMap(url, -4,url, file.name, file.icon_link)
      })
      this.store.dispatch('getResource', {
        urls: downloadUrls.join('\n'),
        downloadPath: this.selectedPath.value.path,
      })
      this.$router.go(-1)
    },
    async download () {
      for (let i = 0; i < this.chooseFile.length; i++) {
        const file = this.chooseFile[i]
        if (file.chooseType !== 0) {
          try {
            await this.store.dispatch('download', { file })
          } catch (err) {
            console.log(err)
          }
        }

      }
      this.store.commit('update', { taskType: 'ing' })
      setTimeout(() => this.store.dispatch('getTasks', { isReplay: true }), 2000)
      this.$router.go(-1)
    },
    async createFolderShow () {
      this.newFolderShow = true
    },
    resetCreateFolderData () {
      this.newFolderShow = false
      this.errorInfo = ''
      this.errorShow = false
    },
    handleInput ({ errorShow, errorInfo }) {
      this.errorShow = errorShow
      this.errorInfo = errorInfo
    },
    async createFolder (filename) {
      const params = {
        name: filename,
        parent_id: this.currentParentId,
        kind: 'drive#folder',
      }

      const [err, res]: [IErrorRes, any] = await request(`${DRIVE_API[Env]}files`, params, { method: 'POST' })
      if (err) {
        console.log('createFolder error ', err)
        this.errorInfo = err.error
        this.errorShow = true
        toast({type: 'error', message: err.error_description})
        return
      }
      console.log('res :>> ', res)
      if (res.file) {
        toast({type: 'success', message: '创建文件夹成功'})
        this.getFiles(this.currentParentId, 'createFolder')
        this.resetCreateFolderData()
      } else {
        console.log('显示错误信息')
        this.errorInfo = res.message
        this.errorShow = true
      }
    },
  },
})
